export default {
  team: {
    sendVerification: "Enviar email de verificación",
    checkVerification: "Ya he verificado mi email",
    verificationSent: "Email de verificación enviado. Abre el enlace y vuelve aquí.",

    rsvpIdentity: "Accede con el email verificado de tu invitación para responder. El acceso RSVP no da acceso al equipo organizador.",
    rsvpNoMatch: "No hay una invitación RSVP activa para este email. Usa la cuenta invitada o pide al organizador que compruebe tu dirección.",
    legacyLink: 'Este antiguo enlace o PIN ya no da acceso al equipo. Pide al propietario que invite tu email y abre Invitaciones recibidas.',
    switchAccount: 'Usar otra cuenta',
  "title": "Equipo y acceso",
  "description": "Elige quién puede ayudarte y a qué secciones puede acceder en este evento.",
  "myInvitations": "Invitaciones recibidas",
  "ownerOnly": "Solo el propietario puede gestionar el equipo. Selecciona un evento propio para invitar a alguien.",
  "invite": "Invitar a alguien",
  "retry": "Reintentar",
  "members": "Personas con acceso",
  "owner": "Propietario",
  "noMembers": "Solo tú tienes acceso. Invita a alguien cuando quieras.",
  "editAccess": "Modificar acceso",
  "remove": "Retirar acceso",
  "invitations": "Invitaciones",
  "noInvitations": "No hay invitaciones pendientes.",
  "pending": "Pendiente de aceptación",
  "cancelled": "Cancelada",
  "expired": "Caducada",
  "cancelInvite": "Cancelar invitación",
  "guestAccess": "¿Y los invitados y enlaces antiguos?",
  "guestHelp": "El equipo ayuda a organizar. Este acceso no envía invitaciones a los invitados ni gestiona sus respuestas RSVP. Los antiguos PIN y enlaces no dan acceso al nuevo sistema de equipo.",
  "legacy": "Hay {{count}} registros de acceso antiguos que revisar. Confirma las direcciones y vuelve a invitar a las personas de confianza con las secciones necesarias.",
  "unknownLegacy": "Acceso antiguo sin un email fiable: confírmalo con la persona.",
  "removeHelp": "Esta persona perderá el acceso al evento. Sus aportaciones se conservarán.",
  "cancelHelp": "Se cancela la invitación y se retira el acceso si ya se ha aceptado. Se conservan las aportaciones.",
  "loadError": "No se han podido cargar los accesos. Inténtalo de nuevo.",
  "actionError": "No se ha podido guardar. Comprueba la conexión y reintenta.",
  "email": "Dirección de email",
  "role": "Nivel de acceso",
  "view": "Puede consultar",
  "edit": "Puede editar",
  "roleHelp": "Consultar: solo lectura. Editar: añadir y modificar elementos. Solo el propietario puede eliminar elementos o gestionar accesos.",
  "sections": "¿Qué secciones?",
  "tasks": "Tareas",
  "guests": "Invitados",
  "budget": "Presupuesto",
  "timeline": "Cronograma",
  "summary": "{{role}} · {{sections}} · {{event}}. El acceso incluye todos los elementos de estas secciones, también los futuros.",
  "selectSections": "Selecciona al menos una sección. El presupuesto solo se comparte si lo seleccionas.",
  "identityHelp": "Las invitaciones caducan a los 7 días. El destinatario debe iniciar sesión con esta dirección verificada. Reenviar el email no da acceso a otra persona.",
  "send": "Enviar invitación",
  "sent": "Invitación enviada. Puedes seguir su estado en Equipo y acceso.",
  "updated": "Acceso actualizado.",
  "deliveryFailed": "La invitación está guardada, pero no se pudo entregar el email. El destinatario puede iniciar sesión y abrir Invitaciones recibidas.",
  "signIn": "Inicia sesión para ver tus invitaciones",
  "verifyEmail": "Verifica tu email y vuelve a iniciar sesión para ver tus invitaciones.",
  "accept": "Aceptar invitación",
  "acceptError": "No se puede aceptar la invitación. Puede haber caducado o sido cancelada.",
  "back": "Volver al panel",
  "sharedEvent": "Compartido contigo",
  "openSection": "Abrir {{section}}",
  "waiting": "Invitación aceptada. Cargando el evento…",
  "sectionDenied": "Esta sección no está incluida en tu acceso. Pide al propietario que cambie tus permisos."
},
  review: {
    "notificationDraft": "Ajusta tus preferencias y guarda los cambios.",
    "markReadError": "No se pudieron actualizar las notificaciones. Inténtalo de nuevo."
},
  accountFlow: {
    "proTitle": "Tu plan: Pro",
    "proHelp": "Gestiona aquí tus eventos, suscripción y facturas.",
    "manageEvents": "Gestionar mis eventos",
    "unsaved": "Cambios sin guardar",
    "instantPreferences": "Las preferencias se aplican inmediatamente.",
    "comparePlans": "Comparar planes",
    "activeEvent": "Evento actual",
    "openEvent": "Abrir",
    "editDetails": "Editar detalles",
    "switchError": "No se pudo cambiar de evento. Inténtalo de nuevo."
},
  organization: {
    "vendorOverview": "Resumen de proveedores",
    "grid": "Cuadrícula",
    "noVendors": "No hay proveedores coincidentes",
    "resetHelp": "Cambia la búsqueda o restablece los filtros para ver tus proveedores.",
    "seatingProgress": "{{placed}} asignados · {{remaining}} por asignar",
    "firstTable": "Crea tu primera mesa",
    "tableHelp": "Añade una mesa para asignar invitados o genera un plano automáticamente.",
    "addTable": "Añadir mesa"
},
  workflow: {
    "scheduleExists": "Los pasos que ya están en el programa no se añadirán de nuevo.",
    "taskView": "Vista de tareas",
    "list": "Lista",
    "kanban": "Tablero",
    "noTasksMatch": "No hay tareas coincidentes",
    "resetTaskHelp": "Cambia la búsqueda o restablece los filtros para ver tus tareas.",
    "previewSchedule": "Ver un programa de ejemplo",
    "scheduleHelp": "Esta plantilla de boda añade los pasos siguientes al programa actual. Después podrás ajustar los horarios y las descripciones.",
    "applySchedule": "Añadir estos pasos"
},
  journey: {
    "guestActions": "Gestionar invitados",
    "openSeating": "Abrir plano de mesas",
    "moreGuestActions": "Compartir, RSVP y más",
    "noGuestResults": "No hay invitados coincidentes",
    "changeGuestSearch": "Cambia la búsqueda o restablece los filtros para ver tus invitados.",
    "firstGuestHelp": "Añade tu primer invitado o importa tu lista desde un archivo CSV.",
    "estimatorOptional": "El estimador te ayuda a planificar el presupuesto. También puedes empezar con los gastos y volver más tarde.",
    "skipEstimator": "Ir a los gastos"
},
  planning: {
    "eyebrow": "Tu espacio de planificación",
    "description": "Consulta tus prioridades y avanza a tu ritmo.",
    "actions": "Acciones de planificación",
    "tasks": "Ver mis tareas",
    "guests": "Invitados",
    "budget": "Presupuesto",
    "pendingCount": "{{count}} pendientes",
    "completedCount": "{{count}} completadas",
    "noDueDate": "Sin fecha límite",
    "overdue": "Atrasada",
    "allDone": "Todo al día: todas las tareas están completadas."
},
  title: "Panel",
  welcome: "Bienvenido a tu panel de bodas",
  daysLeft: "{{days}} días restantes",
  progress: {
    daysLeft: "Quedan {{count}} días"
  },
  overallProgress: "Progreso general",
  tasksCompleted: "Tareas completadas",
  guestsConfirmed: "Invitados confirmados",
  budgetUsed: "Presupuesto usado",
  widgets: {
    countdown: "Cuenta atrás",
    progress: "Progreso",
    tasks: {
      title: "Tareas",
      emptyTitle: "Empieza a organizar",
      emptyDescription: "Agregue las primeras tareas para comenzar a organizar su boda",
      addButton: "Añadir tarea",
      completed: "Terminado",
      inProgress: "En progreso",
      pending: "Por hacer",
      overdue: "Atrasado"
    },
    guests: {
      title: "Invitados",
      emptyTitle: "Gestiona tus invitados",
      emptyDescription: "Empieza a crear tu lista de invitados",
      addButton: "Añadir invitado",
      confirmed: "Confirmados",
      pending: "Pendiente",
      declined: "Rechazados",
      total: "Total"
    },
    budget: {
      title: "Presupuesto",
      emptyTitle: "Gestiona tu presupuesto",
      emptyDescription: "Empieza a seguir tus gastos",
      addButton: "Agregar un gasto",
      spent: "Gastado",
      remaining: "Restante",
      total: "Total",
      currency: "€"
    },
    timeline: {
      title: "Cronología",
      emptyTitle: "Crea tu cronología",
      emptyDescription: "Añade los momentos clave de tu boda",
      addButton: "Añadir evento",
      daysLeft: "Quedan {{count}} días",
      today: "Hoy",
      upcoming: "Próximamente"
    },
    vendors: "Proveedores",
    checklist: "Lista de verificación"
  },
  stats: {
    totalGuests: "Total invitados",
    totalTasks: "Total tareas",
    totalBudget: "Presupuesto total",
    totalVendors: "Total proveedores",
    tasksCompleted: "Tareas terminadas",
    guestsConfirmed: "Invitados confirmados",
    budgetSpent: "Presupuesto gastado",
    daysLeft: "Días restantes"
  },
  quickActions: {
    addTask: "Añadir tarea",
    addGuest: "Añadir invitado",
    addExpense: "Añadir gasto",
    addVendor: "Añadir proveedor",
    title: "Acciones rápidas",
    addEvent: "Añadir evento"
  },
  budgetWidget: {
    title: "Presupuesto",
    subtitle: "Resumen del presupuesto",
    configure: "Configura tu presupuesto para ver estadísticas",
    configureButton: "Configurar"
  },
  guestsWidget: {
    title: "Invitados",
    total: "Total",
    manage: "Gestionar",
    responseRate: "Tasa de respuesta",
    estimatedProgress: "Progreso estimado",
    confirmed: "Confirmados",
    pending: "Pendientes",
    declined: "Rechazados",
    children: "Niños",
    teens: "Adolescentes",
    emptyTitle: "Sin invitados",
    emptyDescription: "Comienza a crear tu lista de invitados",
    addButton: "Añadir invitado"
  },
  tasks: {
    title: "Tareas",
    pending: "Pendientes",
    viewAll: "Ver todo",
    completed: "Completadas",
    noPending: "No hay tareas pendientes",
    empty: {
      title: "Sin tareas",
      description: "Comienza a organizar tu evento añadiendo tareas",
      action: "Añadir tarea"
    },
    categories: {
      legal: "Administrativo",
      venue: "Lugar",
      other: "Otro",
      planning: "Planificación",
      guests: "Invitados"
    }
  },
  progressWidget: {
    title: "Progreso",
    global: "Progreso global",
    daysLeft: "{{count}} días restantes",
    tasks: "Tareas",
    budget: "Presupuesto",
    guests: "Invitados",
    checklist: "Lista de verificación",
    noData: "No hay datos disponibles"
  },
  checklistWidget: {
    title: "Lista de verificación",
    empty: {
      title: "Sin tareas",
      description: "Comienza a crear tu lista de verificación",
      action: "Crear lista"
    },
    subtitle: "Tu progreso",
    noImportant: "Ninguna tarea importante"
  },
  countdown: {
    title: "Cuenta regresiva",
    noDate: "Fecha de la boda no configurada",
    days: "{{count}} Día",
    dayJ: "Días",
    dayJ_zero: "¡Hoy!",
    dayJ_one: "Día",
    dayJ_other: "Días",
    days_plural: "{{count}} Días",
    hours: "{{count}} Hora",
    hoursJ: "Horas",
    hoursJ_zero: "Hora",
    hoursJ_one: "Hora",
    hoursJ_other: "Horas",
    hours_plural: "{{count}} Horas",
    minutes: "{{count}} Minuto",
    minutesJ: "Minutos",
    minutesJ_zero: "Minuto",
    minutesJ_one: "Minuto",
    minutesJ_other: "Minutos",
    minutes_plural: "{{count}} Minutos"
  },
  eventDetails: {
    title: "Detalles del evento",
    subtitle: "{{count}} detalle(s) a completar",
    complete: "Todos los detalles están completos",
    partners: "Pareja",
    location: "Ubicación",
    budget: "Presupuesto",
    highPriority: "Prioridad alta",
    mediumPriority: "Prioridad media",
    lowPriority: "Prioridad baja",
    partner1: "Pareja 1",
    partner2: "Pareja 2",
    venue: "Lugar",
    venuePlaceholder: "Nombre del lugar",
    address: "Dirección",
    addressPlaceholder: "Dirección completa",
    city: "Ciudad",
    cityPlaceholder: "Ciudad",
    totalBudget: "Presupuesto total",
    guestCount: "Número de invitados",
    edit: {
      partners: "Editar pareja",
      location: "Editar ubicación",
      budget: "Editar presupuesto"
    }
  },
  timelineWidget: {
    title: "Cronología",
    subtitle: "Próximos eventos",
    empty: "No hay próximos eventos"
  },
  vendorsWidget: {
    title: "Proveedores",
    total: "{{count}} proveedor(es)",
    add: "Añadir",
    emptyTitle: "Sin proveedores",
    emptyDescription: "Comienza a añadir proveedores para tu evento",
    searchVendors: "Buscar proveedores",
    subtitle: "Gestiona tus proveedores",
    addVendor: "Añadir un proveedor"
  },
  weatherWidget: {
    title: "Tiempo",
    setLocation: "Establecer ubicación",
    addWeather: "Añadir tiempo",
    searchReception: "Buscar lugar de recepción",
    noData: "No hay datos meteorológicos disponibles",
    humidity: "humedad",
    rain: "lluvia",
    currentConditions: "Condiciones actuales en {{location}}",
    historicalTitle: "Datos históricos",
    historicalNote: "Datos meteorológicos históricos para la fecha de tu evento"
  },
  notificationsWidget: {
    title: "Notificaciones",
    unread: "{{count}} sin leer",
    viewAll: "Ver todo",
    markAsRead: "Marcar como leído",
    empty: "Sin notificaciones",
    allRead: "Todas las notificaciones han sido leídas"
  },
  recentActivity: "Actividad reciente",
  upcomingTasks: "Próximas tareas",
  guestsSummary: "Resumen de invitados",
  budgetSummary: "Resumen del presupuesto",
  noUpcomingTasks: "No hay próximas tareas",
  noRecentActivity: "No hay actividad reciente",
  customize: "Personalizar panel",
  layout: "Diseño",
  themes: "Temas",
  preferences: "Preferencias",
  description: "Administre su boda de un vistazo",
  noEventSelected: "Ningún evento seleccionado",
  subtitle: "Resumen de su evento",
  gridView: "Vista de cuadrícula",
  listView: "Vista de lista",
  usage: "Uso",
  "Arrivée des invités": "Llegada de los invitados",
  "Cérémonie": "Ceremonia",
  Cocktail: "Cóctel",
  "Dîner": "Cena",
  "Soirée": "Noche",
  "Préparation": "Preparación",
  account: {
    title: "Cuenta"
  },
  errors: {
    loadingError: "Error al cargar los datos",
    noEventFound: "No se encontró ningún evento",
    markAsRead: "Error al marcar como leído"
  },
  timeline: {
    examples: {
      preparation: {
        title: "Preparación"
      },
      ceremony: {
        title: "Ceremonia"
      },
      cocktail: {
        title: "Cóctel"
      },
      dinner: {
        title: "Cena"
      },
      party: {
        title: "Noche"
      }
    }
  }
};
